export default __webpack_public_path__ + "static/media/issac.d07938dd.PNG";